import { render, staticRenderFns } from "./sbxx开发完成视频控制.vue?vue&type=template&id=12b2d039&scoped=true"
import script from "./sbxx开发完成视频控制.vue?vue&type=script&lang=js"
export * from "./sbxx开发完成视频控制.vue?vue&type=script&lang=js"
import style0 from "./sbxx开发完成视频控制.vue?vue&type=style&index=0&id=12b2d039&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12b2d039",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\华水\\hsmanagementsystem\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('12b2d039')) {
      api.createRecord('12b2d039', component.options)
    } else {
      api.reload('12b2d039', component.options)
    }
    module.hot.accept("./sbxx开发完成视频控制.vue?vue&type=template&id=12b2d039&scoped=true", function () {
      api.rerender('12b2d039', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/hsycjkequipmentmanagement/components/sbxx开发完成视频控制.vue"
export default component.exports